<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="list-of-illustrations">
<h1>List of Illustrations</h1>
<ol style="list-style:none; font-weight:bold; color:#000;">
<li id="toc-li-6"><a href="#/text/Section0001#the-creation">The Creation</a></li>
<li id="toc-li-8"><a href="#/text/ch006#speed-of-life">Speed of Life (After Georgio De Chirico) </a></li>
<li id="toc-li-10"><span href="#/text/ch007#the-thinker-is-confused" title="Link target outside of Sample">The Thinker is Confused (After Rodin) </span></li>
<li id="toc-li-12"><span href="#/text/ch008#dream-of-life" title="Link target outside of Sample">Dream of Life (After Paul Delvaux) </span></li>
<li id="toc-li-14"><span href="#/text/ch009#string-theory-revisited-again" title="Link target outside of Sample">SString Theory Revisited (Again) [After Escher] </span></li>
<li id="toc-li-16"><span href="#/text/ch010#standard-model-of-elementary-particles" title="Link target outside of Sample">Standard Model of Elementary Particles</span></li>
<li id="toc-li-17"><span href="#/text/ch010#where-the-electron-wasnt" title="Link target outside of Sample">Where the Electron Wasn’t (After Winnie the Pooh-
‘Where the Woozle Wasn’t’ and HR Giger) </span></li>
<li id="toc-li-20"><span href="#/text/ch012#eternalismpast-present-and-future" title="Link target outside of Sample">Eternalism—Past, Present and Future (After Remedios Varo)</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?db246962